import React, { FC, ComponentProps, ReactNode, useState, useRef } from 'react'
/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import Analytics from '@lib/Analytics'
import { Button } from '@components/Button'
import { Selector } from '@components/FormInputs/Selector'
import { MiniPopup } from '@components/Popup'
import defaultOptions from './default-options'
import {
  ProductSelectPopupWrapper,
  Title,
  Subtitle,
  Controls,
  QuestionLabel,
  Footer,
  btnStyles,
} from './ProductSelectPopup.elements'

type Props = ComponentProps<typeof MiniPopup> & {
  children?: ReactNode
  products?: {
    text: string
    value: string
  }[]
  onSelectProduct: (product: string) => void
}

export const ProductSelectPopup: FC<Props> = props => {
  const { products = defaultOptions } = props

  const [selectedOption, setSelectedOption] = useState<string>('')

  const popupRef = useRef<MiniPopup>(null)
  const handleClose = () => {
    const { current } = popupRef
    current && current.close()
  }

  const handleChange = (_: string, value: string) => {
    setSelectedOption(value)
  }

  const handleSelectProduct = () => {
    Analytics.log('Click', { location: 'product-select-popup', type: 'continue', product: selectedOption })
    handleClose()
    setTimeout(() => {
      props.onSelectProduct(selectedOption)
    }, 500)
  }

  return (
    <MiniPopup
      {...props}
      ref={popupRef}
    >
      <ProductSelectPopupWrapper>
        <Title>Finally. Special insurance savings that reward the health conscious.</Title>
        <Subtitle>How can we help you today?</Subtitle>

        <Controls>
          <QuestionLabel htmlFor="selector-height">
            Select Product
          </QuestionLabel>
          <Selector
            id="selector-height"
            name=""
            onChange={handleChange}
            value={selectedOption}
            options={products}
            placeholder="Select"
            arrowVariant="lightBlue"
          />

          <Button
            variant="green"
            onClick={handleSelectProduct}
            disabled={!selectedOption}
            aria-label="Navigate to the selected product"
            css={btnStyles}
          >
            Continue
          </Button>
        </Controls>

        <Footer>
          Special rate savings only for Life & Medicare Supplement Insurance.
        </Footer>
      </ProductSelectPopupWrapper>
    </MiniPopup>
  )
}
